import { EChatType, IChat, IChatGroup } from "@deltasge/marauders-map";
import {
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Paper,
} from "@mui/material";
import { Avatar } from "components/Avatar";
import { formatDistance, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import React, { FC } from "react";
import { ListSubheader } from "./ListSubheader";

export const MensagesUnreads: FC<{
  messages: IChatGroup[];
  onClick: (group: IChatGroup, chat: IChat) => void;
}> = ({ messages, onClick }) => {
  return (
    <Paper
      sx={({ spacing }) => ({
        width: spacing(35),
      })}
    >
      {messages.map((group) => {
        return (
          <List
            dense
            key={`group-chat-unreads-${group._id}`}
            subheader={<ListSubheader group={group} />}
          >
            {(group.chats ?? []).map((chat) => {
              const user = group.chatUsers?.find(
                (f) => f.deltaId == chat.fromId
              );
              let context = chat.context;
              if (chat.chatType == EChatType.Attachment)
                context = "Enviou um anexo";
              else if (chat.chatType == EChatType.Audio)
                context = "Enviou um áudio";
              else if (chat.chatType == EChatType.Video)
                context = "Enviou um vídeo";
              else if (chat.chatType == EChatType.Image)
                context = "Enviou uma foto";
              else if (chat.chatType == EChatType.Location)
                context = "Enviou uma localização";
              else if (chat.chatType == EChatType.Sticker)
                context = "Enviou um sticker";
              return (
                <ListItemButton
                  key={`chat-unreads-${chat._id}`}
                  onClick={() => onClick(group, chat)}
                >
                  <ListItemAvatar>
                    <Avatar
                      displayName={user?.nome.rUpper()}
                      src={user?.photoUrl}
                    />
                  </ListItemAvatar>
                  <ListItemText
                    primary={context}
                    secondaryTypographyProps={{
                      noWrap: true,
                      variant: "caption",
                    }}
                    secondary={`${user?.nome.rUpper()} - 
                      ${
                        chat.createdAt &&
                        formatDistance(
                          parseISO(chat.createdAt.toString()),
                          Date.now(),
                          {
                            addSuffix: true,
                            locale: ptBR,
                          }
                        )
                      }`}
                  />
                </ListItemButton>
              );
            })}
          </List>
        );
      })}
    </Paper>
  );
};
